import useSelectionState, { Ticket } from "../../../pages/agent/selection-state";
import { useMarkUnreadMutation } from "../../../__generated__/api";

export default function MarkUnread(): null {
    const selectionState = useSelectionState();
    const [markUnread] = useMarkUnreadMutation();

    const markSelectedUnread = async (tickets?: Ticket[]) => {
        const selected = tickets ?? selectionState.getSelection();
        selectionState.closeCurrent();

        await markUnread({
            variables: {
                chatIds: selected.toIdList("id"),
            },
        });
    };

    selectionState.registerMarkUnreadHandler(markSelectedUnread);

    return null;
}
